



















import { defineComponent } from '@vue/composition-api';
import { ContentLoader } from '@tencent/wphk-components-content-loader';

export default defineComponent({
  components: { ContentLoader },
  name: 'AppContentLoader',
});
